const EmailTemplateKeys = Object.freeze({
  WELCOME: 'welcome',
  SET_PASSWORD: 'setPassword',
  RESET_PASSWORD: 'resetPassword',
  PASSWORD_RESET_SUCCESS: 'passwordResetSuccess',
  API_TOKEN_CREATED: 'apiTokenCreated',
  API_TOKEN_REVOKED: 'apiTokenRevoked',
  API_TOKEN_ALL_REVOKED: 'apiTokenAllRevoked',
  API_TOKEN_DELETED: 'apiTokenDeleted',
  SIGNUP_VERIFY: 'signupVerify',
  MFA_OTP: 'mfaOtp',
  NOTIF_PROJECT_MEMBER_ADDED_SELF: 'notifProjectMemberAddedSelf',
  NOTIF_PROJECT_MEMBER_ADDED_OTHER: 'notifProjectMemberAddedOther',
  NOTIF_PROJECT_MEMBER_REMOVED_SELF: 'notifProjectMemberRemovedSelf',
  NOTIF_PROJECT_MEMBER_REMOVED_OTHER: 'notifProjectMemberRemovedOther',
  NOTIF_TEST_LAUNCH_FINISHED: 'notifTestLaunchFinished',
  NOTIF_AI_COST_THRESHOLD: 'notifAiCostThreshold',
});

const EmailTemplateValues = Object.freeze({
  SUBJECT_WELCOME: 'Welcome to Our Platform',
  SUBJECT_SET_PASSWORD: 'New User Account Created',
  SUBJECT_RESET_PASSWORD: 'Reset Your QA PATH Password',
  SUBJECT_PASSWORD_RESET_SUCCESS: 'Your QA PATH Password Has Been Reset Successfully',
  SUBJECT_API_TOKEN_CREATED: 'New API Token Created',
  SUBJECT_API_TOKEN_REVOKED: 'API Token Revoked',
  SUBJECT_API_TOKEN_ALL_REVOKED: 'All API Tokens Revoked',
  SUBJECT_API_TOKEN_DELETED: 'API Token Deleted',
  SUBJECT_SIGNUP_VERIFY: 'Verify your email to sign up',
  SUBJECT_NOTIF_PROJECT_MEMBER_ADDED_SELF: "You've been added to {projectName}",
  SUBJECT_NOTIF_PROJECT_MEMBER_ADDED_OTHER: '{addedUserName} joined {projectName}',
  SUBJECT_NOTIF_PROJECT_MEMBER_REMOVED_SELF: "You've been removed from {projectName}",
  SUBJECT_NOTIF_PROJECT_MEMBER_REMOVED_OTHER: '{removedUserName} was removed from {projectName}',
  SUBJECT_NOTIF_TEST_LAUNCH_FAILED: 'Test launch failed: {launchName}',
  SUBJECT_NOTIF_TEST_LAUNCH_PASSED: 'Test launch completed: {launchName}',
  SUBJECT_NOTIF_AI_COST_THRESHOLD: 'Your organization has used {percentUsed}% of its AI budget',
  PRODUCT_NAME: 'QA PATH',
  COMPANY_NAME: 'QA PATH',
  COPYRIGHT: '© 2025 QA PATH. All rights reserved.',
  SUBJECT_MFA_OTP: 'Your QA PATH login verification code',
});

/** IDs stored in email-service (DynamoDB); must match POST /templates payloads. */
const EmailServiceTemplateIds = Object.freeze({
  WELCOME: 'welcome',
  SET_PASSWORD: 'set-password',
  RESET_PASSWORD: 'reset-password',
  PASSWORD_RESET_SUCCESS: 'password-reset-success',
  API_TOKEN_CREATED: 'api-token-created',
  API_TOKEN_REVOKED: 'api-token-revoked',
  API_TOKEN_ALL_REVOKED: 'api-token-all-revoked',
  SIGNUP_VERIFY: 'signup-verify',
  MFA_OTP: 'mfa-otp',
  NOTIF_PROJECT_MEMBER_ADDED_SELF: 'notif-project-member-added-self',
  NOTIF_PROJECT_MEMBER_ADDED_OTHER: 'notif-project-member-added-other',
  NOTIF_PROJECT_MEMBER_REMOVED_SELF: 'notif-project-member-removed-self',
  NOTIF_PROJECT_MEMBER_REMOVED_OTHER: 'notif-project-member-removed-other',
  NOTIF_TEST_LAUNCH_FINISHED: 'notif-test-launch-finished',
  NOTIF_AI_COST_THRESHOLD: 'notif-ai-cost-threshold',
});

module.exports = {
  EmailTemplateKeys,
  EmailTemplateValues,
  EmailServiceTemplateIds,
};
